"use strict";
/**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */

Object.defineProperty(exports, "__esModule", {
  value: true
}); //
// Fragments.
//
// tslint:disable-next-line:max-line-length

exports.NC_NAME_START_CHAR = "A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NC_NAME_CHAR = "-" + exports.NC_NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040"; //
// Regular expressions.
//

exports.NC_NAME_START_CHAR_RE = new RegExp("^[" + exports.NC_NAME_START_CHAR + "]$", "u");
exports.NC_NAME_CHAR_RE = new RegExp("^[" + exports.NC_NAME_CHAR + "]$", "u");
exports.NC_NAME_RE = new RegExp("^[" + exports.NC_NAME_START_CHAR + "][" + exports.NC_NAME_CHAR + "]*$", "u");
/**
 * Determines whether a codepoint matches [[NC_NAME_START_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */
// tslint:disable-next-line:cyclomatic-complexity

function isNCNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c === 0x5F || c >= 0x61 && c <= 0x7A || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x200C && c <= 0x200D || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}

exports.isNCNameStartChar = isNCNameStartChar;
/**
 * Determines whether a codepoint matches [[NC_NAME_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */

function isNCNameChar(c) {
  return isNCNameStartChar(c) || c === 0x2D || c === 0x2E || c >= 0x30 && c <= 0x39 || c === 0x00B7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}

exports.isNCNameChar = isNCNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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